"use strict";
/**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */

Object.defineProperty(exports, "__esModule", {
  value: true
}); //
// Fragments.
//
// tslint:disable-next-line:max-line-length

exports.NC_NAME_START_CHAR = "A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NC_NAME_CHAR = "-" + exports.NC_NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040"; //
// Regular expressions.
//

exports.NC_NAME_START_CHAR_RE = new RegExp("^[" + exports.NC_NAME_START_CHAR + "]$", "u");
exports.NC_NAME_CHAR_RE = new RegExp("^[" + exports.NC_NAME_CHAR + "]$", "u");
exports.NC_NAME_RE = new RegExp("^[" + exports.NC_NAME_START_CHAR + "][" + exports.NC_NAME_CHAR + "]*$", "u");
/**
 * Determines whether a codepoint matches [[NC_NAME_START_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */
// tslint:disable-next-line:cyclomatic-complexity

function isNCNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c === 0x5F || c >= 0x61 && c <= 0x7A || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x200C && c <= 0x200D || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}

exports.isNCNameStartChar = isNCNameStartChar;
/**
 * Determines whether a codepoint matches [[NC_NAME_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */

function isNCNameChar(c) {
  return isNCNameStartChar(c) || c === 0x2D || c === 0x2E || c >= 0x30 && c <= 0x39 || c === 0x00B7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}

exports.isNCNameChar = isNCNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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